import React, { FunctionComponent } from "react";

const TradingConversationIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/business-products/trading/trading-conversation
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M17.75 14.75H10.75L4.75 19.25V14.75H2.25C1.45 14.75 0.75 14.05 0.75 13.25V2.25C0.75 1.45 1.45 0.75 2.25 0.75H17.75C18.55 0.75 19.25 1.45 19.25 2.25V13.25C19.25 14.05 18.65 14.75 17.75 14.75Z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M10.25 18.75H13.25L19.25 23.25V18.75H21.75C22.55 18.75 23.25 18.05 23.25 17.25V6.25C23.25 5.45 22.55 4.75 21.75 4.75"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M15.25 4.75L10.05 9.45001L7.75 7.15002L4.75 9.95001"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M11.75 4.75H15.25V8.25"
      ></path>
    </svg>
  );
};

export default TradingConversationIcon;
